enum Role {
  OWNER = "OWNER",
  MANAGER = "MANAGER",
  MEMBER = "MEMBER",
  READ_ONLY = "READ_ONLY",
}

export default Role;
